// extracted by mini-css-extract-plugin
export default {"code":"naayVth4Ei18e_X4V4RW"};